import { SET_CURRENT_DASH } from './constants';
import { createCustomAction } from 'typesafe-actions';
export const setCurrentDash = createCustomAction(SET_CURRENT_DASH, (type) => {
    return (dashboardName: string) => ({ type, dashboardName });
});
